/* SIZESOFTX
=========================================================================================
* Descripción: Configuración de cliente API para Support SizeSoftX
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 11/09/2026 | Lic. José Luis Aragón Cervantes  | Creación
* ---------------------------------------------------------------------------------------
*/

import axios from "axios";
import { clearSession, getSessionToken } from "./supportSession";

export const serverSupport = process.env.REACT_APP_ServerSupport;
export const grafanaUrl = process.env.REACT_APP_GrafanaUrl;

const supportApi = axios.create({
  baseURL: serverSupport,
  timeout: 60000,
});

export const supportPublicApi = axios.create({
  baseURL: serverSupport,
  timeout: 60000,
});

supportApi.interceptors.request.use((config) => {
  // Token solo de sessionStorage: cerrar la pestaña cierra la sesión.
  const token = getSessionToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

supportApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response && err.response.status === 401) {
      clearSession();
      // HashRouter usa el hash (#/login), no el pathname: redirigir por hash.
      if (!String(window.location.hash || "").startsWith("#/login")) {
        window.location.hash = "#/login";
      }
    }
    return Promise.reject(err);
  }
);

export const unwrap = (r) => {
  const d = r.data;
  if (Array.isArray(d)) return d;
  if (d && d.hasError) {
    const error = new Error(d.message || "Error");
    error.httpCode = d.httpCode;
    error.response = r;
    throw error;
  }
  return d ? d.result ?? null : null;
};

export default supportApi;
